import styled from '@emotion/styled';
import { useRouter } from 'next/router';

import { colors } from 'src/styles/colors';
import { ZeeFontRegular } from 'src/styles/font';

import { DynamicObject } from '../../../utils/commonTypes';
import { ContentMetaData } from '../../../utils/ConsumptionHelper/types';
import { mixpanelForMoreLinkClick } from '../../../utils/contentCardHandler';

const NormalText = styled.div`
  margin: 16px 16px 0px 0px;
  ${ZeeFontRegular(18, 24)};
  color: ${colors.PrimaryWhiteColorAlpha50};
`;

const ClickableText = styled.a`
  margin: 16px 16px 0px 0px;
  ${ZeeFontRegular(18, 24)};
  color: ${colors.PurpleLight};
  cursor: pointer;
`;

type TextMessageType = {
  message: string;
  link?: string;
  styles?: any;
  contents?: ContentMetaData[];
  verticalIndex?: number;
  translations?: { [key: string]: DynamicObject };
  railTitle?: string;
  pageName?: string;
  homePageName?: string;
};

const TextMessage = ({
  message,
  link,
  styles,
  contents,
  verticalIndex,
  translations,
  railTitle,
  pageName,
  homePageName
}: TextMessageType) => {
  const router = useRouter();
  const navigate = (e: any, link: string) => {
    e.preventDefault();
    if (contents && verticalIndex && translations) {
      mixpanelForMoreLinkClick(
        contents,
        verticalIndex,
        translations,
        railTitle,
        pageName,
        homePageName
      );
    }
    // Changes done for PWA2-18728 to be uncommented for internal redirection
    // if (link.endsWith('/episodes')) {
    //   router.push(link);
    // } else {
    window.location.href = link;
    // }
  };
  return (
    <div data-testid="text-message-container">
      {link ? (
        <ClickableText
          data-testid="text-message-link"
          href={link}
          css={styles}
          onClick={(e) => navigate(e, link)}>
          {message}
        </ClickableText>
      ) : (
        <NormalText data-testid="text-messsage" css={styles}>
          {message}
        </NormalText>
      )}
    </div>
  );
};

export default TextMessage;
